/**
 * @description A factory for creating data structures used in coin lists.
 */
export const coinListDataFactory = {
  /**
   * @description Creates a list of coin data for categories.
   * @param {string[]} categories - An array of category names.
   * @example
   * const categories = ["Flower", "Edible", "Concentrate"];
   * @param {{ [category: string]: string }} categoryMap - A mapping of category names to their parameter values.
   * @example
   * const categoryMap = {
   *   Concentrate: "Concentrate",
   *   Edible: "Edible",
   *   Flower: "Flower",
   * };
   * @returns {Array<{ icon: string, label: string, value: string }>} - An array of objects containing icon, label, and value for each category.
   * @example
   * [
   *   { icon: "coinList/flower.svg", label: "Flower", value: "Flower" },
   *   { icon: "coinList/edible.svg", label: "Edible", value: "Edible" },
   *   { icon: "coinList/concentrate.svg", label: "Concentrate", value: "Concentrate" },
   * ]
   */
  createCoinListDataForCategories: (
    categories: string[],
    categoryMap: { [category: string]: string },
  ) => {
    return categories.map((category) => ({
      icon: `coinList/${category.toLowerCase()}.svg`,
      label: categoryMap[category],
      value: category,
    }));
  },
  /**
   * @description Creates a list of coin data for shop categories.
   * @param {string[]} categories - An array of category names.
   * @example
   * const categories = ["Flower", "Edible", "Concentrate"];
   * @param {{ [category: string]: string }} categoryMap - A mapping of category names to their parameter values.
   * @example
   * const categoryMap = {
   *   Concentrate: "Concentrates",
   *   Edible: "Edibles",
   *   Flower: "Flower",
   * };
   * @returns {Array<{ icon: string, label: string, value: string }>} - An array of objects containing icon, label, and value for each category.
   * @example
   * [
   *   { icon: "coinList/flower.svg", label: "Flower", value: "Flower" },
   *   { icon: "coinList/edible.svg", label: "Edible", value: "Edibles" },
   *   { icon: "coinList/concentrate.svg", label: "Concentrate", value: "Concentrates" },
   * ]
   */
  createCoinListDataForShopCategories: (
    categories: string[],
    categoryMap: { [category: string]: string },
  ) => {
    return categories.map((category) => ({
      icon: `coinList/${category.toLowerCase()}.svg`,
      label: category,
      value: categoryMap[category],
    }));
  },
};
